import classes from "../Style/Layout.scss";

import Sidebar from './Sidebar';
import { Box, CssBaseline, Paper } from '@mui/material';

import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Outlet, useLocation } from 'react-router-dom';
import PageRoutes from '../Config/PageRoutes';
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";

const Layout = () => {
    const location = useLocation();
    const [isRoot, setIsRoot] = useState(location.pathname === PageRoutes.ROOT);
    useEffect(() => {
        setIsRoot(location.pathname === PageRoutes.ROOT);
    }, [location]);

    return (


        <React.Fragment>
            <CssBaseline />
            <Box sx={{ flexGrow: 1 }} className={isRoot ? 'rootBackground' : ''}>
                <Grid container flexWrap='noWrap' direction={{ xs: 'column', sm: 'column', md: 'row' }}>
                    <Grid item xs="auto" sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
                        <Sidebar isRoot={isRoot} path={location.pathname} />
                    </Grid>
                    <Grid item xs="auto" sx={{ display: { xs: 'block', sm: 'block', md: 'none' }, minHeight: '110px', zIndex: 9999, position: 'sticky', top: 0 }}>
                        <MobileHeader isRoot={isRoot} path={location.pathname} />
                    </Grid>

                    <Grid item xs >
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            {!isRoot && location.pathname !== PageRoutes.CHAPTER_TWO && location.pathname !== PageRoutes.IMPORTANT_CONCEPTS &&
                                <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' }, minHeight: '110px', zIndex: 9999, position: 'sticky', top: 0 }}>
                                    <DesktopHeader isRoot={isRoot} path={location.pathname} />
                                </Box>
                            }
                            <Outlet />
                        </Box>
                    </Grid>

                </Grid>
            </Box>
        </React.Fragment>
    );
}

export default Layout;